// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__ynPRM","file":"styles_file__35AnT"};